import {animate, keyframes, query, stagger, style, transition, trigger} from '@angular/animations';

const timing = '500ms';
const timingFunction = `${timing} cubic-bezier(0, 0, .2, 1)`;

export const notificationAnimation = trigger('notificationListAnimation', [
    transition('* => *', [
        query(':enter', stagger(timing, [
            animate(timingFunction, keyframes([
                style({height: 0, opacity: 0, transform: 'translateX({{fromX}})', offset: 0}),
                style({height: '*', opacity: 0, transform: 'translateX({{fromX}})', offset: 0.75}),
                style({height: '*', opacity: 1, transform: 'translateX({{toX}})', offset: 1.0})
            ]))
        ]), {optional: true}),

        query(':leave', stagger(timing, [
            animate(timingFunction, keyframes([
                style({height: '*', opacity: 1, transform: 'translateX({{toX}})', offset: 0}),
                style({height: '*', opacity: 0, transform: 'translateX({{fromX}})', offset: 0.9}),
                style({height: 0, opacity: 0, transform: 'translateX({{fromX}})', offset: 1.0})
            ]))
        ]), {optional: true})
    ], {params: {fromX: '50%', toX: '0'}})
]);
